import { useContext } from 'react';
import { MenuContext } from 'contexts';

export function useMenu() {
  const context = useContext(MenuContext);

  return context;
}
